import React, { Fragment,Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import './App.css';
import ScrollToTop from "./components/layout/scrollToTop";
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import SGEN from './components/layout/SGEN';
import AboutUs from './components/layout/aboutus';
import Privacy from './components/layout/privacy';
import Terms from './components/layout/terms';
import Documentation from './components/layout/documentation';
import Contribute from './components/layout/contribute';
import Tools from './components/layout/tools';
import Projects from './components/layout/projects';
import Build from './components/layout/build';
import logo from './components/images/toolbox_banner_small.png';
import houseof from './components/images/HouseOf_medium.png';
import donateImage from './components/images/EasterDonate2.png';

class App extends Component {

  state = {
    tools: [
      {
        id: '1',
        companyName: 'SGEN',
        description: 'Script generator is a tool used for creating test cases and documentation. Now featuring OpenAI!',
        url: 'http://sgen.mytestingtools.com/'
      },
      {
        id: '2',
        companyName: 'Github',
        description: 'A code hosting platform for version control and collaboration.',
        url: 'https://github.com/'
      },
      {
        id: '3',
        companyName: 'Jira',
        description: 'Jira Software is built for every member of your software team to plan, track, and release great software. (Free - Up to 10 users)',
        url: 'https://www.atlassian.com/software/jira'
      },
      {
        id: '4',
        companyName: 'Charles',
        description: 'Charles is an HTTP proxy / HTTP monitor / Reverse Proxy that enables a developer to view all of the HTTP and SSL / HTTPS traffic between their machine and the Internet. (Trial)',
        url: 'https://www.charlesproxy.com'
      },
      {
        id: '5',
        companyName: 'Postman',
        description: 'Postman is an API platform for building and using APIs (Free - Up to 3 users)',
        url: 'https://www.postman.com'
      },
      {
        id: '6',
        companyName: 'JWT',
        description: 'JSON Web Tokens are an open, industry standard RFC 7519 method for representing claims securely between two parties.',
        url: 'https://jwt.io'
      },
      {
        id: '7',
        companyName: 'Date to Epoch Converter',
        description: '',
        url: 'https://esqsoft.com/javascript_examples/date-to-epoch.htm'
      },
      {
        id: '8',
        companyName: 'JSON formatter and validator',
        description: '',
        url: 'https://jsonformatter.curiousconcept.com/'
      },
    ],
    automation: [
      {
        id: '1',
        companyName: 'Cypress',
        description: 'Fast, easy and reliable testing for anything that runs in a browser.',
        url: 'https://www.cypress.io/'
      },
      {
        id: '2',
        companyName: 'Protractor',
        description: 'End-to-End test framework for Angular and AngularJS applications (Free)',
        url: 'https://www.protractortest.org/'
      },
      {
        id: '3',
        companyName: 'Selenium',
        description: 'Automating web applications for testing purposes (Free)',
        url: 'https://www.selenium.dev'
      },
      {
        id: '4',
        companyName: 'JUnit',
        description: 'A testing framework for Java and the JVM',
        url: 'https://junit.org/'
      },
      {
        id: '5',
        companyName: 'TestNG',
        description: 'A testing framework inspired from JUnit and NUnit but introducing some new functionality',
        url: 'https://testng.org/'
      },
    ],
    langLib: [
      {
        id: '1',
        companyName: 'Ionic',
        description: 'Ionic is an open source UI toolkit for building performant, high-quality mobile and desktop apps using web technologies — HTML, CSS, and JavaScript — with integrations for popular frameworks like Angular, React, and Vue. (Free)',
        url: 'https://ionicframework.com'
      },
      {
        id: '2',
        companyName: 'Java',
        description: 'Java is a programming language and computing platform (Free)',
        url: 'https://www.java.com/en/'
      },
      {
        id: '3',
        companyName: 'Node',
        description: 'As an asynchronous event-driven JavaScript runtime, Node.js is designed to build scalable network applications. (Free)',
        url: 'https://nodejs.org/en/'
      },
      {
        id: '4',
        companyName: 'Python',
        description: 'Python is a programming language that lets you work quickly and integrate systems more effectively (Free)',
        url: 'https://www.python.org'
      },
      {
        id: '5',
        companyName: 'ReactJS',
        description: 'React is a JavaScript library for building user interfaces (Free)',
        url: 'https://reactjs.org'
      },
    ],
    continuousIntegration: [
      {
        id: '1',
        companyName: 'Jenkins',
        description: 'The leading open source automation server, Jenkins provides hundreds of plugins to support building, deploying and automating any project. (Free)',
        url: 'https://www.jenkins.io'
      },
      {
        id: '2',
        companyName: 'Bamboo',
        description: 'Bamboo Data Center is a continuous delivery pipeline that offers resilience, reliability, and scalability for teams of any size. (Trial)',
        url: 'https://www.atlassian.com/software/bamboo'
      }
    ],
    ideEditors: [
      {
        id: '1',
        companyName: 'Eclipse',
        description: 'The Eclipse IDE, Jakarta EE and over 415 open source projects, including runtimes. (Free)',
        url: 'https://www.eclipse.org/'
      },
      {
        id: '2',
        companyName: 'XCODE',
        description: 'An IDE that provides developers a unified workflow for user interface design, coding, testing, and debugging. (Free)',
        url: 'https://developer.apple.com/xcode/resources/'
      },
      {
        id: '3',
        companyName: 'Visual Studio',
        description: 'The best comprehensive IDE for .NET and C++ developers (Free - Community version)',
        url: 'https://visualstudio.microsoft.com/'
      },
      {
        id: '4',
        companyName: 'PyCharm',
        description: 'The Python IDE for Professional Developers',
        url: 'https://www.jetbrains.com/pycharm/'
      },
      {
        id: '5',
        companyName: 'InteliJ IDEA',
        description: 'An integrated development environment (IDE) for developing computer software.',
        url: 'https://www.jetbrains.com/idea/'
      },
      {
        id: '6',
        companyName: 'VS Code',
        description: 'A lightweight but powerful source code editor (Free)',
        url: 'https://code.visualstudio.com'
      },
      {
        id: '7',
        companyName: 'Sublime Text',
        description: 'A sophisticated text editor for code, markup and prose (Trial)',
        url: 'https://www.sublimetext.com'
      },
    ],
    performance: [
      {
        id: '1',
        companyName: 'Apache JMeter',
        description: 'Designed to load test functional behavior and measure performance.',
        url: 'https://jmeter.apache.org/'
      }
    ],
    education: [
      {
        id: '1',
        companyName: 'UDEMY',
        description: 'An online learning and teaching marketplace.',
        url: 'https://www.udemy.com'
      },
      {
        id: '2',
        companyName: 'CodeAcademy',
        description: 'Learn the technical skills to get the job you want.',
        url: 'https://www.codecademy.com/'
      },
      {
        id: '3',
        companyName: 'Coursera',
        description: 'Build new skills for that “this is my year” feeling with courses, certificates, and degrees from world-class universities and companies.',
        url: 'https://www.coursera.org/'
      },
      {
        id: '4',
        companyName: 'Harvard Online',
        description: 'Online access to course materials, lectures, programs and other educational content for free.',
        url: 'https://pll.harvard.edu/'
      },
      {
        id: '5',
        companyName: 'Khan Academy',
        description: 'We’re a nonprofit with the mission to provide a free, world-class education for anyone, anywhere.',
        url: 'https://www.khanacademy.org/'
      },
      {
        id: '6',
        companyName: 'MIT Courseware',
        description: 'Coursework available for free to the public.',
        url: 'https://ocw.mit.edu/index.htm'
      },
      {
        id: '7',
        companyName: 'FreeCodeCamp',
        description: 'Learn to code — for free',
        url: 'https://www.freecodecamp.org/'
      },
    ],
    adspace: [
      {
        id: '1',
        companyName: '',
        description: '',
        url: ''
      },
      {
        id: '1',
        companyName: '',
        description: '',
        url: ''
      },
      {
        id: '1',
        companyName: '',
        description: '',
        url: ''
      }
    ],
  }

  render() {
    return (
      <Router>
      <ScrollToTop />
      <div className="container">
        <Navbar title='My Testing Tools' icon='fas fa-tools'/>
        <Switch>
          <Route exact path="/" render={props =>(
            <Fragment>
                <div className='img-container'>
                  <img src={logo} alt="toolbox"/>
                </div>
                <div className='img-container'>
                  <img src={houseof} alt="house"/>
                </div>
                <div className='grid-3'>
                  <div className='card'>
                    <div className='HeaderBar'>Tools</div>
                    <div className='cardContents'>
                      {this.state.tools.map((item) =>
                                  <a href={item.url} key={item.id}><b>{item.companyName}</b> - {item.description}<br/><br/></a>

                              )}
                    </div>
                  </div>
                  <div className='card'>
                    <div className='HeaderBar'>Automation</div>
                    <div className='cardContents'>
                      {this.state.automation.map((item) =>
                                  <a href={item.url} key={item.id}><b>{item.companyName}</b> - {item.description}<br/><br/></a>

                              )}
                    </div>
                  </div>
                  <div className='card'><a href="https://www.paypal.com/donate/?hosted_button_id=FFERGTCZNAFLN" ><img src={donateImage} alt="Donate Today!"/></a></div>
                </div> 
                <div className='grid-3'>
                  <div className='card'>
                    <div className='HeaderBar'>Languages / Libraries</div>
                    <div className='cardContents'>
                      {this.state.langLib.map((item) =>
                                  <a href={item.url} key={item.id}><b>{item.companyName}</b> - {item.description}<br/><br/></a>

                              )}
                    </div>
                  </div>
                  <div className='card'>
                    <div className='HeaderBar'>IDE / Editors</div>
                    <div className='cardContents'>
                      {this.state.ideEditors.map((item) =>
                                  <a href={item.url} key={item.id}><b>{item.companyName}</b> - {item.description}<br/><br/></a>

                              )}
                    </div>
                  </div>
                  <div className='card'>
                    <div className='HeaderBar'>Performance Testing</div>
                    <div className='cardContents'>
                      {this.state.performance.map((item) =>
                                  <a href={item.url} key={item.id}><b>{item.companyName}</b> - {item.description}<br/><br/></a>

                              )}
                    </div>
                  </div>
                </div> 
                <div className='grid-2'>
                  <div className='card'>
                    <div className='HeaderBar'>Education</div>
                    <div className='cardContents'>
                      {this.state.education.map((item) =>
                                  <a href={item.url} key={item.id}><b>{item.companyName}</b> - {item.description}<br/><br/></a>

                              )}
                    </div>
                  </div>
                  <div className='card'>
                  <div className='cardContents'>
                      {this.state.adspace.map((item) =>
                                  <a href={item.url} key={item.id}><b>{item.companyName}</b> {item.description}<br/><br/></a>

                              )}
                    </div>
                  </div>
                </div>

            </Fragment>
          )} />
          <Route exact path='/SGEN' component={SGEN} />
          <Route exact path='/aboutus' component={AboutUs} />
          <Route exact path='/privacy' component={Privacy} />
          <Route exact path='/terms' component={Terms} />
          <Route exact path='/documentation' component={Documentation} />
          <Route exact path='/contribute' component={Contribute} />
          <Route exact path='/tools' component={Tools} />
          <Route exact path='/projects' component={Projects} />
          <Route exact path='/build' component={Build} />
        </Switch> 
        <Footer title='My Testing Tools' icon='fas fa-tools'/>
      </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js